import React from 'react'
import { object } from 'prop-types'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import createRoutes from './config/routes'

class Root extends React.Component {
  render() {
    const { store, history } = this.props

    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>{createRoutes()}</ConnectedRouter>
      </Provider>
    )
  }
}

Root.propTypes = {
  store: object.isRequired,
  history: object.isRequired
}

export default Root
